import { fabric } from "fabric";
import { getMinScaleForMaskedObject } from "./helpers/object";

export default class DeskpadImage {
  constructor(url) {
    this.imageUrl = url;
  }

  getCut = (canvas) => {
    const defaultCutSettings = { cutEnabled: true, cutSize: 3 };
    const settings = { ...defaultCutSettings, ...canvas.settings };
    const { cutEnabled, cutSize } = settings;
    const cut = cutEnabled && cutSize * 2;
    return cut;
  };

  addToCanvas = (canvas, props) => {
    const { fitTo, url, placeholder, width, height, hash } = props;

    fabric.Image.fromURL(
      placeholder,
      (img) => {
        // const filter = new fabric.Image.filters.Blur({
        //   blur: 0.5
        // });
        // img.filters.push(filter);
        // img.applyFilters();
        img.clipId = fitTo.id;
        img.src = url;
        img.clipPath = fitTo;
        img.size = { width, height };
        img.evented = false;
        img.selectable = false;
        img.originX = "center";
        img.originY = "center";
        img.hash = hash;

        const scaleUpK = 1;
        const scale = getMinScaleForMaskedObject(img, fitTo) * scaleUpK;
        img.set({ scaleX: scale, scaleY: scale });
        img.setPositionByOrigin(fitTo.getCenterPoint(), "center", "center");
        img.setCoords();
        img.generateId();
        canvas.add(img);
        const fitToIndex = canvas
          .getObjects()
          .findIndex((obj) => obj === fitTo);
        if (fitToIndex > -1) {
          img.moveTo(fitToIndex + 1);
        }
        canvas.requestRenderAll();
        img.setSrc(url, (e) => {
          const scale = getMinScaleForMaskedObject(e, fitTo) * scaleUpK;
          e.set({ scaleX: scale, scaleY: scale });
          e.setPositionByOrigin(fitTo.getCenterPoint(), "center", "center");

          e.setCoords();

          canvas.requestRenderAll();
        });
      },
      { crossorigin: "anonymous" }
    );
  };

  //TODO: split it :S
  loadOnCanvas = (
    canvas,
    props,
    placeholderUrl = null,
    fit = true,
    fitInside = false
  ) => {
    let { left = 0, top = 0, width, height, hash, isVector = false } = props;
    if (props.scaleX) {
      width *= props.scaleX;
      height *= props.scaleY;
    }

    const imagePlaceholderObj = new fabric.Rect({
      left: left,
      top: top,
      width: width,
      height: height,
      fill: "rgb(0,0,0,0.5)",
      stroke: "#444",
      strokeWidth: 1,
    });

    const progressObj = new fabric.Rect({
      left: left,
      top: top,
      width: 0,
      height: height,
      fill: "rgb(255,255,255)",
      opacity: 0.4,
      stroke: "#444",
      strokeWidth: 1,
    });

    const activityIndicator = new fabric.Rect({
      left: left + width / 2,
      top: top + height / 2,
      width: width / 20,
      height: width / 20,
      fill: "rgb(255,255,255)",
      originX: "center",
      originY: "center",
      opacity: 0.7,
      stroke: "#444",
      strokeWidth: width / 100,
    });

    const animateIndicator = () => {
      activityIndicator.animate("angle", "+=360", {
        duration: 1500,
        onChange: canvas.renderAll.bind(canvas),
        easing: (t, b, c, d) => {
          return c / 2 + (-c + (c / d) * t);
        }, //fabric.util.ease.easeInSine
      });
    };
    animateIndicator();
    const animationInterval = setInterval(animateIndicator, 1500);

    const imageLoaderGroup = new fabric.Group(
      [imagePlaceholderObj, progressObj, activityIndicator],
      {
        left: left,
        top: top,
        src: this.imageUrl,
        size: { width, height },
        // selectable: false,
        objectCaching: false,
        excludeFromExport: true,
      }
    );
    canvas.add(imageLoaderGroup);
    if (fit) {
      if (fitInside) {
        this.placeInsideCanvas(canvas, imageLoaderGroup);
      } else {
        this.fitToCutZone(canvas, imageLoaderGroup);
      }
    }

    imageLoaderGroup.moveTo(9999);

    if (placeholderUrl) {
      fabric.Image.fromURL(
        placeholderUrl,
        function (img) {
          img.left = imageLoaderGroup.left;
          img.top = imageLoaderGroup.top;
          img.width = imageLoaderGroup.getScaledWidth();
          img.height = imageLoaderGroup.getScaledHeight();

          const filter = new fabric.Image.filters.Blur({
            blur: 0.5,
          });
          img.filters.push(filter);
          img.applyFilters();
          imageLoaderGroup.remove(imagePlaceholderObj);

          imageLoaderGroup.addWithUpdate(img);
          img.moveTo(-999);
        },
        { crossOrigin: "anonymous" }
      );
    }
    //FIXME: rework to make animation smooth
    this.load((progress) => {
      progressObj.set({ width: width * progress * 0.01 });
      canvas.requestRenderAll();
    }).then((image) => {
      const { url, type } = image;
      if (type === "raster") {
        fabric.Image.fromURL(
          url,
          function (img) {
            img.scaleToWidth(imageLoaderGroup.getScaledWidth());
            img.top = imageLoaderGroup.top;
            img.left = imageLoaderGroup.left;
            img.isVector = isVector;
            img.size = {
              width: props.width,
              height: props.height,
            };
            img.src = url;
            if (placeholderUrl) {
              img.thumb = placeholderUrl;
            }
            if (hash) {
              img.hash = hash;
            }
            //it means that response for caching returned faster then img preview finished loading
            if (imageLoaderGroup.hash) {
              img.src = imageLoaderGroup.src;
              img.thumb = imageLoaderGroup.thumb;
              img.hash = imageLoaderGroup.hash;
            }
            img.generateId();
            img.crossOrigin = "anonymous";
            // img.set({ originX: "center", originY: "center" });
            canvas.requestRenderAll()
            canvas.add(img);
            canvas.remove(imageLoaderGroup);
            clearInterval(animationInterval);
            img.bringToFront();
            canvas.cutZone.cutzone.bringToFront();
          },
          { crossOrigin: "anonymous" }
        );
      } else {
        fabric.loadSVGFromURL(url, function (objects, options) {
          const svgData = fabric.util.groupSVGElements(objects, options);
          svgData.src = url;
          svgData.isVector = isVector;
          // svgData.set({ originX: "center", originY: "center" });
          if (placeholderUrl) {
            svgData.thumb = placeholderUrl;
          }
          svgData.size = {
            width: props.width,
            height: props.height,
          };
          svgData.src = url;
          if (placeholderUrl) {
            svgData.thumb = placeholderUrl;
          }
          if (hash) {
            svgData.hash = hash;
          }
          svgData.scaleToWidth(imageLoaderGroup.getScaledWidth());
          svgData.top = imageLoaderGroup.top;
          svgData.left = imageLoaderGroup.left;
          svgData.isSVG = true;
          svgData.generateId();
          canvas.requestRenderAll();
          canvas.add(svgData);
          canvas.remove(imageLoaderGroup);
          clearInterval(animationInterval);
          svgData.bringToFront();
          canvas.cutZone.cutzone.bringToFront();
        });
      }
    });
  };

  fitToCutZone = (canvas, oImg) => {
    const cutObj = canvas
      .getObjects()
      .find((obj) => obj.id === "cutzone");
    this.fitToObj(canvas, oImg, cutObj);
  };

  placeInsideCanvas = (canvas, oImg) => {
    const cutObj = canvas
      .getObjects()
      .find((obj) => obj.id === "cutzone");
    this.placeInsideObj(canvas, oImg, cutObj);
  };

  placeInsideObj = (canvas, obj, targetObj) => {
    const zoom = canvas.getZoom();
    const cut = 0; //this.getCut(canvas);

    let scaleToW = (targetObj.width + cut) * zoom;
    let scaleToH = (targetObj.height + cut) * zoom;
    obj.scaleToWidth(scaleToW + 50);
    const minDPI = canvas.settings.minDPI ? canvas.settings.minDPI : 40;
    const mmInInch = 1 / 25.4;
    const widthInInch = obj.width * obj.scaleX * mmInInch;
    const actualPixelWidth = obj?.size?.width ?? 99999;
    const DPI = actualPixelWidth / widthInInch;
    const maxScaleX = actualPixelWidth / (minDPI * obj.width * mmInInch);
    if (DPI < minDPI) {
      obj.scaleX = maxScaleX;
      obj.scaleY = maxScaleX;
      obj.setCoords();
    } else {
      if (obj.getScaledWidth() > targetObj.width) {
        obj.scaleToWidth(scaleToW);
        if (obj.getScaledHeight() > targetObj.height) {
          obj.scaleToHeight(scaleToH);
        }
      }
    }
    const pos = new fabric.Point(
      (targetObj.width + cut) / 2,
      (targetObj.height + cut) / 2
    );
    obj.setPositionByOrigin(pos, "center", "center");
    obj.setCoords();
    canvas.requestRenderAll();
  };

  fitToObj = (canvas, obj, targetObj) => {
    const zoom = canvas.getZoom();
    const cut = 0; //this.getCut(canvas);
    let scaleToW = (targetObj.width + cut) * zoom;
    let scaleToH = (targetObj.height + cut) * zoom;
    obj.scaleToWidth(scaleToW + 50);
    const { minDPI } = canvas.settings;
    if (minDPI) {
      const mmInInch = 1 / 25.4;
      const widthInInch = obj.width * obj.scaleX * mmInInch;
      const actualPixelWidth = obj.size.width;
      const DPI = !obj.isVector ? actualPixelWidth / widthInInch : 10000;
      const maxScaleX = actualPixelWidth / (minDPI * obj.width * mmInInch);
      if (DPI < minDPI) {
        obj.scaleX = maxScaleX;
        obj.scaleY = maxScaleX;
        obj.setCoords();
      } else {
        if (obj.getScaledWidth() > targetObj.width) {
          obj.scaleToWidth(scaleToW);
          if (obj.getScaledHeight() < targetObj.height) {
            obj.scaleToHeight(scaleToH);
          }
        }
      }
      const pos = new fabric.Point(
        (targetObj.width + cut) / 2,
        (targetObj.height + cut) / 2
      );
      obj.setPositionByOrigin(pos, "center", "center");
      obj.setCoords();
      canvas.requestRenderAll();
    }
  };

  load = (onprogress) => {
    const { imageUrl } = this;
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.imageType = "raster";
      xhr.onprogress = (ev) => {
        if (ev.lengthComputable) {
          onprogress(parseInt((ev.loaded / ev.total) * 100, 10));
        } else {
          onprogress(-1);
        }
      };

      xhr.onloadend = () => {
        if (!xhr.status.toString().match(/^2/)) {
          reject(xhr);
        } else {
          resolve({ url: imageUrl, type: xhr.imageType });
        }
      };

      xhr.onreadystatechange = function () {
        if (this.readyState === this.HEADERS_RECEIVED) {
          const type = xhr.getResponseHeader("Content-Type");
          if (type === "image/svg+xml") {
            xhr.imageType = "vector";
          }
        }
      };
      xhr.open("GET", imageUrl, true);
      xhr.responseType = "arraybuffer";
      xhr.send();
    });
  };
}

fabric.Object.prototype.fitToCutZone = function () {
  new DeskpadImage().fitToCutZone(this.canvas, this);
  this.canvas.fire("object:scaling", { target: this });
};

fabric.Object.prototype.generateId = function () {
  this.id = Math.random().toString(36).substr(2, 6);
};

fabric.Object.prototype.lock = function (state) {
  this.lockMovementX = state;
  this.lockMovementY = state;
  this.lockScalingX = state;
  this.lockScalingY = state;
  this.lockUniScaling = state;
  this.lockRotation = state;
};

fabric.Object.prototype.placeInsideCutZone = function () {
  const cutObj = this.canvas
    .getObjects()
    .find((obj) => obj.id === "cutzone");
  new DeskpadImage().placeInsideObj(this.canvas, this, cutObj);
  this.canvas.fire("object:scaling", { target: this });
};
